import type { ReactNode } from "react";

export function PageHeader({
  eyebrow,
  title,
  description,
  titleAction,
  children,
}: {
  eyebrow: string;
  title: string;
  description?: ReactNode;
  titleAction?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <header>
      <div>
        <span>{eyebrow}</span>
        <div className="page-header-title">
          <h1>{title}</h1>
          {titleAction}
        </div>
        {description && <p className="page-header-description">{description}</p>}
      </div>
      {children}
    </header>
  );
}
